import { useTranslation } from 'react-i18next'
import TileBlur from '@ui/tiles/TileBlur'
import Gradient from '@ui/effects/Gradient'
import { colors as c } from '@ui/colors'
import { View } from 'react-native'
import Status from '@ui/elements/Status'

import refundBalanceImg from '@/images/coins-refund-min.png'

export default function RefundBalanceStatusInfo() {
  const { t } = useTranslation(['payment', 'status'])

  return (
    <TileBlur.Provider variant="option">
      <TileBlur.Glass
        image={refundBalanceImg}
        imageStyle={{
          transform: [{ translateX: -25 }, { translateY: 0 }],
        }}
        blurStyle={{
          opacity: 0.9,
          transform: [
            { translateX: 100 },
            { translateY: -25 },
            { rotate: '15deg' },
            { scale: 0.75 },
          ],
        }}
        gradient={
          <Gradient
            colors={[c.gray[50], c.white0]}
            start={[0, 0.5]}
            end={[1, 0.5]}
          />
        }
        style={{ height: 'auto' }}
      >
        <View className="flex w-full flex-col gap-0">
          <View className="flex flex-row px-8 py-8" style={{ minHeight: 224 }}>
            <View className="flex-1 flex-col justify-between gap-4">
              <TileBlur.Title
                title={t('payment:status.refundBalance.title')}
                desc={t('payment:status.refundBalance.desc')}
              />
              <View className="flex flex-row items-center justify-start">
                <Status
                  text={t('status:payment.new.completed.long')}
                  variant="success"
                />
              </View>
            </View>
          </View>
        </View>
      </TileBlur.Glass>
    </TileBlur.Provider>
  )
}
